import React from 'react';
import PropTypes from 'prop-types';
import { Numbers } from '../../../../helpers';
import {
  HeadingContainer,
  TagDeuda,
  TagContainer,
  ChevronIconStyled as ChevronIcon,
} from './styles/ItemHeadingStyled';

const ItemHeading = ({ data, toggled, click }) => {
  const status = (() => {
    const rawStatus = data.status;
    const statusChoices = {
      created: {
        code: 'created',
        text: 'Emitida',
      },
      warning: {
        code: 'warning',
        text: 'Por vencer',
      },
      not_paid: {
        code: 'not_paid',
        text: 'Vencida',
      },
      paid: {
        code: 'paid',
        text: 'Pagada',
      },
    };
    return statusChoices[rawStatus];
  })();

  return (
    <>
      <HeadingContainer onClick={click} open={toggled}>
        <div>
          <h2>{data.month}</h2>
          <TagContainer>
            <p>Total: ${Numbers.addThousandSeparators(data.amount)}</p>
            <TagDeuda code={status.code}>{status.text}</TagDeuda>
          </TagContainer>
        </div>
        <div>
          <ChevronIcon open={toggled} />
        </div>
      </HeadingContainer>
    </>
  );
};

ItemHeading.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  toggled: PropTypes.bool.isRequired,
  click: PropTypes.func.isRequired,
};

export default ItemHeading;
